import styled from 'styled-components';
import {StrategyProductCard, StrategyWideCardColumn} from '../Strategy/styles';

/** Evita overflow horizontal em layouts flex no celular */
export const CalcWideCardColumn = styled(StrategyWideCardColumn)`
    min-width: 0;
    width: 100%;
`;

/** Card um pouco mais compacto no mobile — mais espaço útil para abas e formulário */
export const CalcPageCard = styled(StrategyProductCard)`
    @media (max-width: 767px) {
        padding: 14px 12px 16px !important;
        border-radius: 14px !important;
        margin-bottom: 24px !important;
    }
`;

/**
 * Wrapper da calculadora (abas Bootstrap). Mantido para compatibilidade.
 */
export const Container = styled.div`
    .active {
        font-weight: bold;
    }

    a {
        color: rgba(200, 210, 230, 0.88);
    }

    a.nav-link.active {
        color: #f29205;
    }
`;

/** Área de abas da calculadora — tema escuro alinhado ao /estrategias */
export const CalcTabsArea = styled.div`
    padding: 4px 0 12px;
    color: rgba(232, 234, 255, 0.92);
    min-width: 0;
    width: 100%;
    box-sizing: border-box;

    @media (min-width: 768px) {
        padding: 8px 8px 20px;
    }

    hr {
        border-color: rgba(255, 255, 255, 0.1);
    }

    .h4 {
        color: #f2f4ff;
    }

    /* Mobile: 4 abas em fila com scroll — evita quebra feia e overflow da página */
    .nav-tabs-calc {
        border-bottom: 1px solid rgba(242, 146, 5, 0.22);
        flex-wrap: nowrap;
        gap: 6px;
        margin-bottom: 0;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: rgba(242, 146, 5, 0.35) transparent;
        padding-bottom: 4px;

        &::-webkit-scrollbar {
            height: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(242, 146, 5, 0.35);
            border-radius: 4px;
        }
    }

    @media (min-width: 768px) {
        .nav-tabs-calc {
            flex-wrap: wrap;
            overflow-x: visible;
            padding-bottom: 0;
        }
    }

    .nav-tabs-calc .nav-item {
        margin-bottom: 0;
        flex-shrink: 0;
    }

    .nav-tabs-calc .nav-link {
        color: rgba(200, 210, 230, 0.88) !important;
        border: 1px solid transparent !important;
        border-radius: 10px 10px 0 0;
        padding: 10px 12px;
        font-weight: 600;
        font-size: 12px;
        white-space: nowrap;
        transition: all 0.2s ease;
        background: transparent !important;
    }

    @media (min-width: 768px) {
        .nav-tabs-calc .nav-link {
            padding: 10px 14px;
            font-size: 13px;
        }
    }

    .nav-tabs-calc .nav-link:hover {
        color: #ffffff !important;
        background: rgba(242, 146, 5, 0.1) !important;
        border-color: rgba(242, 146, 5, 0.25) !important;
    }

    .nav-tabs-calc .nav-link.active {
        color: #f29205 !important;
        background: rgba(242, 146, 5, 0.14) !important;
        border-color: rgba(242, 146, 5, 0.4) !important;
        border-bottom-color: transparent !important;
        box-shadow: 0 -2px 14px rgba(242, 146, 5, 0.12);
    }

    .tab-content {
        color: #e8eaf4;
        padding-top: 1.25rem;
        min-width: 0;
    }

    @media (max-width: 767px) {
        .tab-content {
            padding-top: 0.875rem;
        }
    }

    .tab-pane {
        animation: calcFadeIn 0.25s ease;
    }

    @keyframes calcFadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
